module.exports = __webpack_public_path__ + "media/images/arrow_select-a238867d477efef61a85b0b7902aeb12.png";